<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import { hasModuleAccess } from '@/utils/menuAccess';

export default {
  page: {
    title: "Roles Management",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Roles Management",
      items: [
        { text: "Roles", href: "/" },
        { text: "Manage Roles", active: true },
      ],
      roles: [],
      selectedRoleId: null,
      selectedRoleUsers: [],
      allMenus: [],
      roleMenus: [],
      country: [],
      mine: {},
      allUsers: [],
      selectedUserIds: [],
      newRoleName: '',
      newRoleIsAdmin: false,
      loadingRoles: true,
      loadingUsers: false,
      loadingMenus: false,
      loadingAssignUsers: false,
      loadingCreateRole: false,
      loadingCreateUser: false,
      loadingEditUser: false,
      loadingDeleteUser: false,
      buttonSeen: true,
      typeUser: [],
      fullname: '',
      email: '',
      phonenumber: '',
      password: '',
      confirm_password: '',
      country_: '',
      user_id: '',
      showAddRoleModal: false,
      showAddUserModal: false,
      showEditUserModal: false,
      showAssignUsersModal: false,
      showEditRoleModal: false,
      showDeleteUserModal: false,
      activeTab: 'roles',
      userFilterRole: 'all',
      searchRoles: '',
      searchUsers: '',
      searchAssignUsers: '',
      errorMessage: '',
    };
  },
  computed: {
    hasRolesModuleAccess() {
      return hasModuleAccess("User");
    },
    rolesWithUserCount() {
      let filteredRoles = this.roles;
      if (!this.isAdminRole) {
        filteredRoles = this.roles.filter(role => this.mine.roles?.some(r => String(r.id) === String(role.id)));
      }
      filteredRoles = filteredRoles.map(role => {
        const userCount = this.allUsers.filter(user => user.roles.some(r => String(r.id) === String(role.id))).length;
        return { ...role, userCount };
      });
      if (this.searchRoles) {
        const searchLower = this.searchRoles.toLowerCase();
        filteredRoles = filteredRoles.filter(role => role.name.toLowerCase().includes(searchLower));
      }
      return filteredRoles;
    },
    selectedRoleName() {
      const role = this.roles.find(r => String(r.id) === String(this.selectedRoleId));
      return role ? role.name : 'Unknown Role';
    },
    isAdminRole() {
      return this.mine.roles?.some(r => r.is_admin) || false;
    },
    filteredUsers() {
      let filtered = this.allUsers;
      if (this.userFilterRole === 'all') {
        filtered = this.allUsers;
      } else if (this.userFilterRole === 'none') {
        filtered = this.allUsers.filter(user => user.roles.length === 0);
      } else {
        filtered = this.allUsers.filter(user => user.roles.some(role => String(role.id) === String(this.userFilterRole)));
      }
      if (this.searchUsers) {
        const searchLower = this.searchUsers.toLowerCase();
        filtered = filtered.filter(user => user.name.toLowerCase().includes(searchLower));
      }
      return filtered;
    },
    filteredAssignUsers() {
      let filtered = this.allUsers;
      if (this.searchAssignUsers) {
        const searchLower = this.searchAssignUsers.toLowerCase();
        filtered = filtered.filter(user => user.name.toLowerCase().includes(searchLower));
      }
      return filtered;
    },
  },
  watch: {
    selectedRoleId(newRoleId) {
      if (newRoleId) {
        this.getUsersForRole(newRoleId);
      }
    },
    userFilterRole(newFilter) {
      console.log("Filter changed to:", newFilter);
    },
  },
  methods: {
    showError(message) {
      this.errorMessage = message;
      setTimeout(() => (this.errorMessage = ''), 5000);
    },
    myProfile() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_API_BASEURL + 'user/my')
        .then(response => {
          if (response.data) {
            this.mine = response.data;
          } else {
            this.showError('No user profile found.');
          }
        })
        .catch(error => {
          this.showError('Error fetching profile: ' + (error.response?.data?.msj || error.message));
        });
    },
    getCountries() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_API_BASEURL + 'country')
        .then(response => {
          if (response.data && response.data.status !== 'error') {
            this.country = response.data;
          } else {
            this.showError('No countries found: ' + response.data.msj);
          }
        })
        .catch(error => {
          this.showError('Error fetching countries: ' + (error.response?.data?.msj || error.message));
        });
    },
    async getRoles() {
      this.loadingRoles = true;
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      try {
        const response = await axios.get(process.env.VUE_APP_API_BASEURL + 'roles');
        if (response.data) {
          this.roles = response.data;
          await this.getAllUsers();
        } else {
          this.showError('No roles found.');
        }
      } catch (error) {
        this.showError('Error fetching roles: ' + (error.response?.data?.msj || error.message));
      } finally {
        this.loadingRoles = false;
      }
    },
    async getAllUsers() {
      this.loadingUsers = true;
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      try {
        const response = await axios.get(process.env.VUE_APP_API_BASEURL + 'user/list');
        if (response.data) {
          this.allUsers = response.data;
          if (this.selectedRoleId) {
            this.getUsersForRole(this.selectedRoleId);
          }
        } else {
          this.showError('No users found.');
        }
      } catch (error) {
        this.showError('Error fetching users: ' + (error.response?.data?.msj || error.message));
      } finally {
        this.loadingUsers = false;
      }
    },
    getUsersForRole(roleId) {
      this.loadingUsers = true;
      const filteredUsers = this.allUsers.filter(user => user.roles.some(role => String(role.id) === String(roleId)));
      this.selectedRoleUsers = filteredUsers;
      this.selectedRoleId = roleId;
      this.loadingUsers = false;
    },
    editRoleMenus(roleId) {
      this.selectedRoleId = roleId;
      this.loadingMenus = true;
      this.showEditRoleModal = true;
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_API_BASEURL + 'menu/all')
        .then(response => {
          if (response.data) {
            this.allMenus = response.data;
            axios.get(process.env.VUE_APP_API_BASEURL + 'menu/mainmenu/' + roleId)
              .then(response => {
                this.roleMenus = response.data.map(menu => ({
                  ...menu,
                  isExpanded: menu.IsSelect,
                }));
                this.loadingMenus = false;
              })
              .catch(error => {
                this.showError('Error fetching role menus: ' + (error.response?.data?.msj || error.message));
                this.loadingMenus = false;
              });
          } else {
            this.showError('No menus found.');
            this.loadingMenus = false;
          }
        })
        .catch(error => {
          this.showError('Error fetching all menus: ' + (error.response?.data?.msj || error.message));
          this.loadingMenus = false;
        });
    },
    toggleMainMenu(menu) {
      if (menu.IsSelect) {
        menu.isExpanded = true;
        menu.manu.forEach(submenu => {
          submenu.isSubMenu = true;
          submenu.disabled = false;
        });
      } else {
        menu.isExpanded = false;
        menu.manu.forEach(submenu => {
          submenu.isSubMenu = false;
          submenu.disabled = true;
        });
      }
    },
    saveRoleMenus(e) {
      e.preventDefault();
      this.buttonSeen = true;
      const payload = {
        menu: this.roleMenus.filter(item => item.IsSelect).map(item => item.id),
        submenu: this.roleMenus.flatMap(item => item.manu.filter(sub => sub.isSubMenu && !sub.disabled).map(sub => sub.id)),
      };
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.post(process.env.VUE_APP_API_BASEURL + 'menu/assign/' + this.selectedRoleId, payload)
        .then(response => {
          if (response.data.status === 'successfully') {
            this.buttonSeen = false;
            this.showEditRoleModal = false;
            this.showError('Menus updated successfully!', 'success');
          } else {
            this.showError('Failed to update menus: ' + response.data.msj);
            this.buttonSeen = false;
          }
        })
        .catch(error => {
          this.showError('Error updating menus: ' + (error.response?.data?.msj || error.message));
          this.buttonSeen = false;
        });
    },
    addNewRole(e) {
      e.preventDefault();
      if (!this.newRoleName) {
        this.showError('Role name is required.');
        return;
      }
      this.loadingCreateRole = true;
      const payload = {
        name: this.newRoleName,
        is_admin: this.newRoleIsAdmin,
      };
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.post(process.env.VUE_APP_API_BASEURL + 'roles', payload)
        .then(response => {
          if (response.data.status === 'success') {
            document.getElementById('AddNewRole').reset();
            this.newRoleName = '';
            this.newRoleIsAdmin = false;
            this.getRoles();
            this.showAddRoleModal = false;
            this.showError('Role created successfully!', 'success');
          } else {
            this.showError('Failed to create role: ' + response.data.msj);
          }
        })
        .catch(error => {
          this.showError('Error creating role: ' + (error.response?.data?.msj || error.message));
        })
        .finally(() => {
          this.loadingCreateRole = false;
        });
    },
    addNewUser(e) {
      e.preventDefault();
      if (this.password !== this.confirm_password) {
        this.showError('Passwords do not match.');
        return;
      }
      this.loadingCreateUser = true;
      const typeUserArray = Array.isArray(this.typeUser) ? this.typeUser : [];
      const payload = {
        role_ids: typeUserArray,
        name: this.fullname,
        email: this.email,
        password: this.password,
        country_id: this.country_ || null,
        phonenumber: this.phonenumber || null,
        password_confirmation: this.confirm_password,
      };
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.post(process.env.VUE_APP_API_BASEURL + 'user/create', payload)
        .then(response => {
          if (response.data.status === 'success') {
            document.getElementById('AddNewUser').reset();
            this.fullname = '';
            this.email = '';
            this.phonenumber = '';
            this.password = '';
            this.confirm_password = '';
            this.country_ = '';
            this.typeUser = [];
            this.getAllUsers();
            if (this.selectedRoleId && this.activeTab === 'roles') {
              this.getUsersForRole(this.selectedRoleId);
            }
            this.showAddUserModal = false;
            this.showError('User created successfully!', 'success');
          } else {
            this.showError('Failed to create user: ' + (response.data.msj || 'Unknown error'));
          }
        })
        .catch(error => {
          if (error.response?.status === 422 && error.response.data.errors) {
            const errors = error.response.data.errors;
            const errorMessages = Object.values(errors).flat().join(', ');
            this.showError('Validation failed: ' + errorMessages);
          } else {
            this.showError('Error creating user: ' + (error.response?.data?.msj || error.message));
          }
        })
        .finally(() => {
          this.loadingCreateUser = false;
        });
    },
    openEditUserModal(user) {
      this.user_id = user.id;
      this.fullname = user.name;
      this.email = user.email;
      this.phonenumber = user.phone_no || '';
      this.typeUser = user.roles.map(role => role.id);
      this.country_ = user.country_id || '';
      this.password = '';
      this.confirm_password = '';
      this.showEditUserModal = true;
    },
    editUser(e) {
      e.preventDefault();
      if (this.password && this.password !== this.confirm_password) {
        this.showError('Passwords do not match.');
        return;
      }
      this.loadingEditUser = true;
      const payload = {
        user_id: this.user_id,
        name: this.fullname,
        email: this.email,
        phone_no: this.phonenumber,
        role_ids: Array.isArray(this.typeUser) ? this.typeUser : [],
        country_id: this.country_,
      };
      if (this.password) {
        payload.password = this.password;
      }
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.post(process.env.VUE_APP_API_BASEURL + 'user/update', payload)
        .then(response => {
          if (response.data.status === 'success') {
            document.getElementById('EditUser').reset();
            this.fullname = '';
            this.email = '';
            this.phonenumber = '';
            this.password = '';
            this.confirm_password = '';
            this.country_ = '';
            this.typeUser = [];
            this.user_id = '';
            this.getAllUsers();
            if (this.selectedRoleId && this.activeTab === 'roles') {
              this.getUsersForRole(this.selectedRoleId);
            }
            this.showEditUserModal = false;
            this.showError('User updated successfully!', 'success');
          } else {
            this.showError('Failed to update user: ' + response.data.msj);
          }
        })
        .catch(error => {
          this.showError('Error updating user: ' + (error.response?.data?.msj || error.message));
        })
        .finally(() => {
          this.loadingEditUser = false;
        });
    },
    openAssignUsersModal(roleId) {
      this.selectedRoleId = roleId;
      this.selectedUserIds = [];
      this.searchAssignUsers = '';
      this.loadingAssignUsers = true;
      this.showAssignUsersModal = true;
      this.getAllUsers();
      this.loadingAssignUsers = false;
    },
    assignUsers(e) {
      e.preventDefault();
      if (!this.selectedUserIds.length) {
        this.showError('Please select at least one user.');
        return;
      }
      this.loadingAssignUsers = true;
      const payload = { user_ids: this.selectedUserIds };
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.post(process.env.VUE_APP_API_BASEURL + 'roles/assign-users/' + this.selectedRoleId, payload)
        .then(response => {
          if (response.data.status === 'success') {
            this.getAllUsers();
            this.getUsersForRole(this.selectedRoleId);
            this.selectedUserIds = [];
            this.showAssignUsersModal = false;
            this.showError('Users assigned successfully!', 'success');
          } else {
            this.showError('Failed to assign users: ' + response.data.msj);
          }
        })
        .catch(error => {
          this.showError('Error assigning users: ' + (error.response?.data?.msj || error.message));
        })
        .finally(() => {
          this.loadingAssignUsers = false;
        });
    },
    removeUserFromRole(userId) {
      this.user_id = userId;
      this.showDeleteUserModal = true;
    },
    confirmRemoveUserFromRole(e) {
      e.preventDefault();
      this.loadingDeleteUser = true;
      const payload = { user_id: this.user_id };
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.post(process.env.VUE_APP_API_BASEURL + 'roles/remove-user/' + this.selectedRoleId, payload)
        .then(response => {
          if (response.data.status === 'success') {
            this.getAllUsers();
            if (this.selectedRoleId && this.activeTab === 'roles') {
              this.getUsersForRole(this.selectedRoleId);
            }
            this.showDeleteUserModal = false;
            this.user_id = '';
            this.showError('User removed from role successfully!', 'success');
          } else {
            this.showError('Failed to remove user from role: ' + response.data.msj);
          }
        })
        .catch(error => {
          this.showError('Error removing user from role: ' + (error.response?.data?.msj || error.message));
        })
        .finally(() => {
          this.loadingDeleteUser = false;
        });
    },
    deleteUser(userId) {
      this.user_id = userId;
      this.showDeleteUserModal = true;
    },
    confirmDeleteUser(e) {
      e.preventDefault();
      this.loadingDeleteUser = true;
      const payload = { user_id: this.user_id };
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.post(process.env.VUE_APP_API_BASEURL + 'user/delete_user', payload)
        .then(response => {
          if (response.data.status === 'success') {
            this.getAllUsers();
            if (this.selectedRoleId && this.activeTab === 'roles') {
              this.getUsersForRole(this.selectedRoleId);
            }
            this.showDeleteUserModal = false;
            this.user_id = '';
            this.showError('User deleted successfully!', 'success');
          } else {
            this.showError('Failed to delete user: ' + response.data.msj);
          }
        })
        .catch(error => {
          this.showError('Error deleting user: ' + (error.response?.data?.msj || error.message));
        })
        .finally(() => {
          this.loadingDeleteUser = false;
        });
    },
  },
  components: {
    Layout,
    PageHeader,
  },
  mounted() {
    if (this.hasRolesModuleAccess) {
      this.myProfile();
      this.getRoles();
      this.getCountries();
    } else {
      this.showError('You are not authorized to view this page!');
    }
  },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div v-if="hasRolesModuleAccess">
      <!-- Error/Success Message -->
      <div v-if="errorMessage" :class="['alert', errorMessage.includes('success') ? 'alert-success' : 'alert-danger']" role="alert">
        {{ errorMessage }}
      </div>

      <div class="d-flex justify-content-end mb-3" v-if="isAdminRole">
        <button class="btn btn-primary me-2" @click="showAddRoleModal = true" v-if="activeTab === 'roles'">
          <i class="ri-add-line align-middle me-1"></i> Add New Role
        </button>
        <button class="btn btn-primary" @click="showAddUserModal = true" v-if="activeTab === 'users'">
          <i class="ri-add-line align-middle me-1"></i> Add New User
        </button>
      </div>

      <!-- Tabs -->
      <ul class="nav nav-tabs mb-3" role="tablist">
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'roles' }" @click="activeTab = 'roles'" href="#roles" role="tab">Roles</a>
        </li>
        <li class="nav-item" v-if="isAdminRole">
          <a class="nav-link" :class="{ active: activeTab === 'users' }" @click="activeTab = 'users'" href="#users" role="tab">Users</a>
        </li>
      </ul>

      <!-- Tab Content -->
      <div class="tab-content">
        <!-- Roles Tab -->
        <div class="tab-pane" :class="{ active: activeTab === 'roles' }" id="roles" role="tabpanel">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title mb-0">Roles</h5>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <label for="searchRoles" class="form-label">Search Roles by Name</label>
                <input type="text" v-model="searchRoles" class="form-control" id="searchRoles" placeholder="Enter role name" />
              </div>
              <div v-if="loadingRoles" class="text-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div v-else-if="rolesWithUserCount.length === 0" class="text-center">
                No roles available
              </div>
              <div v-else>
                <div class="table-responsive">
                  <table class="table table-striped table-nowrap mb-0">
                    <thead class="table-primary">
                      <tr>
                        <th>No.</th>
                        <th>Name</th>
                        <th>Users Assigned</th>
                        <th>Is Admin</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(role, index) in rolesWithUserCount" :key="role.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ role.name }}</td>
                        <td>{{ role.userCount }}</td>
                        <td>{{ role.is_admin ? 'Yes' : 'No' }}</td>
                        <td>
                          <button class="btn btn-sm btn-info me-1" @click="getUsersForRole(role.id)">
                            <i class="ri-eye-fill"></i> View Users
                          </button>
                          <button class="btn btn-sm btn-warning me-1" @click="editRoleMenus(role.id)" v-if="isAdminRole">
                            <i class="bx bx-wrench"></i> Edit Menus
                          </button>
                          <button class="btn btn-sm btn-success" @click="openAssignUsersModal(role.id)" v-if="isAdminRole">
                            <i class="ri-user-add-line"></i> Assign Users
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- Users Table for Selected Role -->
          <div class="card mt-4" v-if="selectedRoleId">
            <div class="card-header">
              <h5 class="card-title mb-0">Users in Role: {{ selectedRoleName }}</h5>
            </div>
            <div class="card-body">
              <div v-if="loadingUsers" class="text-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div v-else-if="selectedRoleUsers.length === 0" class="text-center">
                No users assigned to this role
              </div>
              <div v-else>
                <div class="table-responsive">
                  <table class="table table-striped table-nowrap mb-0">
                    <thead class="table-primary">
                      <tr>
                        <th>No.</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone Number</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(user, index) in selectedRoleUsers" :key="user.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ user.name }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.phone_no || 'N/A' }}</td>
                        <td>
                          <button class="btn btn-sm btn-danger" @click="removeUserFromRole(user.id)" v-if="isAdminRole">
                            <i class="ri-delete-bin-5-fill"></i> Remove from Role
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Users Tab -->
        <div class="tab-pane" :class="{ active: activeTab === 'users' }" id="users" role="tabpanel" v-if="isAdminRole">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title mb-0">Users</h5>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <label for="searchUsers" class="form-label">Search Users by Name</label>
                <input type="text" v-model="searchUsers" class="form-control" id="searchUsers" placeholder="Enter user name" />
              </div>
              <div class="mb-3">
                <label for="userFilterRole" class="form-label">Filter by Role</label>
                <select v-model="userFilterRole" class="form-select" id="userFilterRole">
                  <option value="all">All Roles</option>
                  <option value="none">No Role</option>
                  <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
                </select>
              </div>
              <div v-if="loadingUsers" class="text-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div class="table-responsive">
                  <table class="table table-striped table-nowrap mb-0">
                    <thead class="table-primary">
                      <tr>
                        <th>No.</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone Number</th>
                        <th>Roles</th>
                        <th>Country</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(user, index) in filteredUsers" :key="user.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ user.name }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.phone_no || 'N/A' }}</td>
                        <td>{{ user.roles.length ? user.roles.map(r => r.name).join(', ') : 'None' }}</td>
                        <td>{{ country.find(c => String(c.id) === String(user.country_id))?.name || 'N/A' }}</td>
                        <td>
                          <button class="btn btn-sm btn-warning me-1" @click="openEditUserModal(user)">
                            <i class="bx bx-edit"></i> Edit
                          </button>
                          <button class="btn btn-sm btn-danger" @click="deleteUser(user.id)">
                            <i class="ri-delete-bin-5-fill"></i> Delete
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Add New Role Modal -->
      <div class="modal fade" :class="{ show: showAddRoleModal }" v-if="showAddRoleModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add New Role</h5>
              <button type="button" class="btn-close" @click="showAddRoleModal = false"></button>
            </div>
            <div class="modal-body">
              <form @submit="addNewRole" id="AddNewRole">
                <div class="row g-3">
                  <div class="col-12">
                    <label for="newRoleName" class="form-label">Role Name <span class="text-danger">*</span></label>
                    <input type="text" v-model="newRoleName" class="form-control" id="newRoleName" placeholder="Enter Role Name" required />
                  </div>
                  <div class="col-12">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" v-model="newRoleIsAdmin" id="newRoleIsAdmin">
                      <label class="form-check-label" for="newRoleIsAdmin">Is Admin Role</label>
                    </div>
                  </div>
                  <div class="col-12 text-end">
                    <button type="button" class="btn btn-light me-2" @click="showAddRoleModal = false">Cancel</button>
                    <button type="submit" class="btn btn-primary" :disabled="loadingCreateRole">
                      <span v-if="loadingCreateRole" class="spinner-border spinner-border-sm me-1"></span>
                      Add Role
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Add New User Modal -->
      <div class="modal fade" :class="{ show: showAddUserModal }" v-if="showAddUserModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add New User</h5>
              <button type="button" class="btn-close" @click="showAddUserModal = false"></button>
            </div>
            <div class="modal-body">
              <form @submit="addNewUser" id="AddNewUser">
                <div class="row g-3">
                  <div class="col-12">
                    <label for="fullname" class="form-label">Full Name <span class="text-danger">*</span></label>
                    <input type="text" v-model="fullname" class="form-control" id="fullname" placeholder="Enter Full Name" required />
                  </div>
                  <div class="col-12">
                    <label class="form-label">Roles</label>
                    <select v-model="typeUser" class="form-select" multiple>
                      <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
                    </select>
                  </div>
                  <div class="col-12" v-if="mine.country_id == null">
                    <label class="form-label">Country</label>
                    <select v-model="country_" class="form-select">
                      <option value="" disabled>Select Country</option>
                      <option v-for="item in country" :key="item.id" :value="item.id">{{ item.name }}</option>
                    </select>
                  </div>
                  <div class="col-12">
                    <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                    <input type="email" v-model="email" class="form-control" id="email" placeholder="Enter Email" required />
                  </div>
                  <div class="col-12">
                    <label for="phonenumber" class="form-label">Phone Number</label>
                    <input type="text" v-model="phonenumber" class="form-control" id="phonenumber" placeholder="Enter Phone Number" />
                  </div>
                  <div class="col-12">
                    <label for="password" class="form-label">Password <span class="text-danger">*</span></label>
                    <input type="password" v-model="password" class="form-control" id="password" placeholder="Enter Password" required />
                  </div>
                  <div class="col-12">
                    <label for="confirm_password" class="form-label">Confirm Password <span class="text-danger">*</span></label>
                    <input type="password" v-model="confirm_password" class="form-control" id="confirm_password" placeholder="Confirm Password" required />
                  </div>
                  <div class="col-12 text-end">
                    <button type="button" class="btn btn-light me-2" @click="showAddUserModal = false">Cancel</button>
                    <button type="submit" class="btn btn-primary" :disabled="loadingCreateUser">
                      <span v-if="loadingCreateUser" class="spinner-border spinner-border-sm me-1"></span>
                      Add User
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit User Modal -->
      <div class="modal fade" :class="{ show: showEditUserModal }" v-if="showEditUserModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit User</h5>
              <button type="button" class="btn-close" @click="showEditUserModal = false"></button>
            </div>
            <div class="modal-body">
              <form @submit="editUser" id="EditUser">
                <div class="row g-3">
                  <div class="col-12">
                    <label for="editFullname" class="form-label">Full Name <span class="text-danger">*</span></label>
                    <input type="text" v-model="fullname" class="form-control" id="editFullname" placeholder="Enter Full Name" required />
                  </div>
                  <div class="col-12">
                    <label class="form-label">Roles</label>
                    <select v-model="typeUser" class="form-select" multiple>
                      <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
                    </select>
                  </div>
                  <div class="col-12" v-if="mine.country_id == null">
                    <label class="form-label">Country</label>
                    <select v-model="country_" class="form-select">
                      <option value="" disabled>Select Country</option>
                      <option v-for="item in country" :key="item.id" :value="item.id">{{ item.name }}</option>
                    </select>
                  </div>
                  <div class="col-12">
                    <label for="editEmail" class="form-label">Email <span class="text-danger">*</span></label>
                    <input type="email" v-model="email" class="form-control" id="editEmail" placeholder="Enter Email" required />
                  </div>
                  <div class="col-12">
                    <label for="editPhonenumber" class="form-label">Phone Number</label>
                    <input type="text" v-model="phonenumber" class="form-control" id="editPhonenumber" placeholder="Enter Phone Number" />
                  </div>
                  <div class="col-12">
                    <label for="editPassword" class="form-label">Password</label>
                    <input type="password" v-model="password" class="form-control" id="editPassword" placeholder="Enter New Password (Optional)" />
                  </div>
                  <div class="col-12">
                    <label for="editConfirmPassword" class="form-label">Confirm Password</label>
                    <input type="password" v-model="confirm_password" class="form-control" id="editConfirmPassword" placeholder="Confirm New Password (Optional)" />
                  </div>
                  <div class="col-12 text-end">
                    <button type="button" class="btn btn-light me-2" @click="showEditUserModal = false">Cancel</button>
                    <button type="submit" class="btn btn-primary" :disabled="loadingEditUser">
                      <span v-if="loadingEditUser" class="spinner-border spinner-border-sm me-1"></span>
                      Update User
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Assign Users to Role Modal -->
      <div class="modal fade" :class="{ show: showAssignUsersModal }" v-if="showAssignUsersModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Assign Users to Role</h5>
              <button type="button" class="btn-close" @click="showAssignUsersModal = false"></button>
            </div>
            <div class="modal-body">
              <form @submit="assignUsers">
                <div v-if="loadingAssignUsers" class="text-center">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                <div v-else>
                  <div class="mb-3">
                    <label for="searchAssignUsers" class="form-label">Search Users by Name</label>
                    <input type="text" v-model="searchAssignUsers" class="form-control" id="searchAssignUsers" placeholder="Enter user name" />
                  </div>
                  <div class="table-responsive">
                    <table class="table table-striped table-nowrap mb-0">
                      <thead class="table-primary">
                        <tr>
                          <th>Select</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Current Roles</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="user in filteredAssignUsers" :key="user.id">
                          <td>
                            <input type="checkbox" v-model="selectedUserIds" :value="user.id" class="form-check-input">
                          </td>
                          <td>{{ user.name }}</td>
                          <td>{{ user.email }}</td>
                          <td>{{ user.roles.length ? user.roles.map(r => r.name).join(', ') : 'None' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="text-end mt-3">
                    <button type="button" class="btn btn-light me-2" @click="showAssignUsersModal = false">Cancel</button>
                    <button type="submit" class="btn btn-primary" :disabled="loadingAssignUsers">
                      <span v-if="loadingAssignUsers" class="spinner-border spinner-border-sm me-1"></span>
                      Assign Selected Users
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Role Menus Modal -->
      <div class="modal fade" :class="{ show: showEditRoleModal }" v-if="showEditRoleModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content bg-white rounded-lg shadow-2xl">
            <div class="modal-header bg-gray-100 border-b border-gray-200 p-4">
              <h5 class="modal-title text-xl font-semibold text-gray-800">Edit Menus for {{ selectedRoleName }}</h5>
              <button type="button" class="btn-close text-gray-600 hover:text-gray-800 transition-colors duration-200" @click="showEditRoleModal = false"></button>
            </div>
            <div class="modal-body p-6">
              <div v-if="loadingMenus" class="text-center">
                <div class="spinner-border text-blue-500" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div v-else>
                <form @submit="saveRoleMenus">
                  <div class="space-y-4">
                    <div v-for="(menu, index) in roleMenus" :key="index" class="menu-item bg-gray-50 rounded-lg p-4 hover:shadow-lg hover:bg-gray-100 transition-all duration-300">
                      <div class="form-check form-switch flex items-center">
                        <input
                          class="form-check-input w-12 h-6 cursor-pointer transition-transform duration-300 checked:bg-blue-600 hover:bg-gray-400"
                          type="checkbox"
                          v-model="menu.IsSelect"
                          :id="'menu-' + menu.id"
                          @change="toggleMainMenu(menu)"
                          :aria-label="'Toggle menu ' + menu.name"
                        >
                        <label
                          class="form-check-label ml-3 text-gray-700 font-medium hover:text-blue-600 transition-colors duration-200 cursor-pointer"
                          :for="'menu-' + menu.id"
                        >
                          {{ menu.name }}
                        </label>
                      </div>
                      <div class="submenu-container ml-8 mt-3 overflow-hidden" :class="{ 'submenu-open': menu.isExpanded, 'submenu-closed': !menu.isExpanded }" v-if="menu.manu && menu.manu.length">
                        <div v-for="(submenu, subIndex) in menu.manu" :key="subIndex" class="form-check flex items-center py-1">
                          <input
                            class="form-check-input w-5 h-5 cursor-pointer transition-transform duration-300 checked:bg-blue-600 hover:bg-gray-400 disabled:bg-gray-200"
                            type="checkbox"
                            v-model="submenu.isSubMenu"
                            :id="'submenu-' + submenu.id"
                            :disabled="!menu.IsSelect"
                            :aria-label="'Toggle submenu ' + submenu.name"
                          >
                          <label
                            class="form-check-label ml-3 text-gray-600 hover:text-blue-600 transition-colors duration-200 cursor-pointer"
                            :for="'submenu-' + submenu.id"
                            :class="{ 'text-gray-400': !menu.IsSelect }"
                          >
                            {{ submenu.name }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-end mt-6 space-x-3">
                    <button
                      type="button"
                      class="btn bg-gray-200 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-300 hover:scale-105 transition-all duration-200"
                      @click="showEditRoleModal = false"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      class="btn bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 hover:scale-105 transition-all duration-200"
                    >
                      Update Menus
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Remove User from Role Modal -->
      <div class="modal fade" :class="{ show: showDeleteUserModal }" v-if="showDeleteUserModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body text-center p-5">
              <form @submit="confirmRemoveUserFromRole" id="confirmRemoveUser">
                <h4 class="mb-3">Are you sure you want to remove this user from {{ selectedRoleName }}?</h4>
                <input type="hidden" v-model="user_id" id="user_id" />
                <div class="hstack gap-2 justify-content-center">
                  <button type="button" class="btn btn-light" @click="showDeleteUserModal = false">Cancel</button>
                  <button type="submit" class="btn btn-danger" :disabled="loadingDeleteUser">
                    <span v-if="loadingDeleteUser" class="spinner-border spinner-border-sm me-1"></span>
                    Remove
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      You don't have permission to view this page
    </div>
  </Layout>
</template>

<style scoped>
/* Tailwind CSS CDN (for development; in production, configure via npm) */
@import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');

/* Modal animations */
.modal.fade .modal-dialog {
  transform: scale(0.8);
  opacity: 0;
  transition: all 0.3s ease-out;
}

.modal.show .modal-dialog {
  transform: scale(1);
  opacity: 1;
}

.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
}

.modal.show {
  display: block;
}

.modal-dialog.modal-lg {
  max-width: 800px;
  margin: 1.75rem auto;
}

.modal-content {
  border-radius: 0.5rem;
  overflow: hidden;
}

/* Modal header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Enhanced toggle switch styling */
.form-check-input {
  appearance: none;
  -webkit-appearance: none;
  width: 2.5rem; /* Larger for main menu */
  height: 1.5rem;
  border-radius: 0.75rem;
  background-color: #b5b7b9; /* Tailwind gray-300 */
  border: none;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.form-check-input::before {
  content: '';
  position: absolute;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background-color: #ecf2f7;
  top: 0.125rem;
  left: 0.125rem;
  transition: transform 0.3s ease;
}

.form-check-input:checked {
  background-color: #3b82f6; /* Tailwind blue-600 */
}

.form-check-input:checked::before {
  transform: translateX(1rem);
}

.form-check-input:hover {
  background-color: #9ca3af; /* Tailwind gray-400 */
}

.form-check-input:disabled {
  background-color: #9ca3af; /* Tailwind gray-200 */
  cursor: not-allowed;
}

.form-check-input:disabled::before {
  background-color: #9ca3af; /* Tailwind gray-300 */
}

/* Submenu toggle (smaller size) */
.form-check:not(.form-switch) .form-check-input {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0.25rem;
}

.form-check:not(.form-switch) .form-check-input::before {
  width: 0.75rem;
  height: 0.75rem;
  top: 0.25rem;
  left: 0.25rem;
}
/* Submenu dropdown animation */
.submenu-container {
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  max-height: 0;
  opacity: 0;
}

.submenu-container.submenu-open {
  max-height: 500px; /* Adjust based on content */
  opacity: 1;
}

.submenu-container.submenu-closed {
  max-height: 0;
  opacity: 0;
}

/* Menu item hover effect */
.menu-item {
  transition: all 0.3s ease-in-out;
}

.menu-item:hover {
  transform: translateY(-2px);
}

/* Override Bootstrap table styles */
.card {
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.table th, .table td {
  vertical-align: middle;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
}

.alert {
  margin-bottom: 1rem;
}
</style>